// API-adapter layer for the stem feature: maps fitted-component API payloads to the
// view-model's SelectableStem shape. Pure presentation derivations live in stemSelectableItems.ts;
// clinical rules live in @/domain/catalog.
import type { CatalogHead } from '@/domain/catalog/head';
import { type CatalogStem, stemTypeInfo } from '@/domain/catalog/stem';
import { getCatalogComponent } from '@/domain/catalog/catalog';
import { type ApiFittedStem, isSuitableStem } from '@/api/fittedComponents/fittedStem';
import type { SelectableStem } from './stem.types';

// Build the selectable stem constructs from the fitted components and catalog.
// TODO maybe we should revisit this as we don't really need to load in default stem + head constructs with the new
//  manual selection method
export const buildFittedStemConstructs = (
    fittedStems: Map<string, ApiFittedStem>,
    catalogStems: Map<string, CatalogStem>,
    catalogHeads: Map<string, CatalogHead>,
): SelectableStem[] =>
    Array.from(fittedStems.values()).map((stem) => {
        const catalogStem = getCatalogComponent(catalogStems, stem.catalogUrl);
        const info = stemTypeInfo(catalogStem.type);
        const catalogHead = getCatalogComponent(catalogHeads, stem.head.catalogUrl);
        return {
            name: `${info.profile} ${catalogStem.size} ${info.offset}`,
            stemUrl: stem.catalogUrl,
            catalogStem,
            headUrl: stem.head.catalogUrl,
            catalogHead,
            suitable: isSuitableStem(stem),
        };
    });